import React, { useState } from 'react'
import {
    Box,
    Button,
    HStack,
    ModalBody,
    ModalFooter,
    ModalHeader,
    Text,
    useToast,
    VStack,
    Image,
    FormLabel,
} from "@chakra-ui/react";
import { CloudArrowUp } from "phosphor-react";
import { useFormik } from "formik";
import Noimg from "../../Assets/profile_placeholder.jpg";
import { XCircle } from "phosphor-react";
import * as yup from "yup";
import { COLORS } from "../../Helper/Colors";
import { FormInput } from "../../Components/Common/UI";
import DotSpinner from "../../Components/Common/DotSpinner";
import { TextArea } from "../../Components/Common/UI/TextArea";
import Api from "../../Helper/ApiHandler";
import { useRef } from "react";

export const AddEditNotificationModal = ({ type, initialValues = "", onClose }) => {
    const [isImageChanged, setisImageChanged] = useState(false);
    const api = new Api();

    const [currentimg, setcurrentimg] = useState(
        initialValues.photo ? initialValues.photo : null
    );
    const schema = yup.object().shape({

        title: yup.string().required("Title Is Required!"),
        content: yup.string().required('Content Is required')

    });

    const toast = useToast();
    const [btnLoading, setBtnLoading] = useState(false);
    const inputElement = useRef();
    const clickInput = (event) => {
        inputElement.current.click();
    };
    const handleSubmit = async (values) => {
        try {
            if (type == "ADD") {
                const formData = new FormData();
                if (values.image) {

                    formData.append("image", values.image);
                }
                formData.append("title", values.title);
                formData.append("content", values.content);

                let data = await api.post(`${"notification/create"}`, formData);

                toast({
                    description: ` ${data.message}`,
                    status: "success",
                    duration: 3000,
                    isClosable: false,
                    position: "top",
                });
            }
            else {
                const formData = new FormData();
                formData.append("image",)
                //update
            }
        }
        catch (err) {

            console.log("error", err)
        }

    }
    const handleinput = (event) => {
        setisImageChanged(true);

        if (event.target.files && event.target.files[0]) {
            formik.setFieldTouched("image", true, true);
            formik.setValues({
                ...formik.values,
                image: event.target.files[0],
            });
            setcurrentimg(URL.createObjectURL(event.target.files[0]));
        }
    };
    const formik = useFormik({
        initialValues: initialValues,
        validationSchema: schema,
        onSubmit: handleSubmit,
    });
    const handleChange = (name, value) => {
        formik.setFieldTouched(name, true, true);
        formik.setValues({ ...formik.values, [name]: value });
    };
    const { values, touched, errors } = formik;
    return (
        <Box
            display={"flex"}
            flexDirection={"column"}
            width={"100%"}
            height={"100%"}
            overflow={"auto"}
            padding={4}
            paddingBottom={2}
        >
            <ModalHeader
                display={"flex"}
                flex="1"
                width={"100%"}
                justifyContent={"space-between"}
                alignItems="center"
            >

                <HStack
                    display={"flex"}
                    flex="1"
                    alignItems="center"
                    fontWeight={"600"}
                    color={COLORS.brandDark}
                >
                    <Text>{type === "ADD" ? "CREATE" : "UPDATE"}</Text>
                    <Text ml={1}>NOTIFICATION</Text>
                </HStack>
                <XCircle
                    height="24"
                    width="24"
                    onClick={onClose}
                    cursor={"pointer"}
                    color={COLORS.lightGray}
                />
            </ModalHeader>
            <form
                onSubmit={formik.handleSubmit}
                style={{ overflow: "auto" }}
                className={"design-scrollbar"}
            >
                <ModalBody className={"design-scrollbar"}>
                    <VStack spacing={4} width={"100%"} alignItems={"stretch"}>
                        <HStack>
                            <input
                                type={"file"}
                                hidden
                                ref={inputElement}
                                onChange={handleinput}
                                name="image"
                            ></input>
                            <VStack>
                                <HStack>
                                    <Image
                                        src={currentimg ? currentimg : Noimg}
                                        width={"70px"}
                                        hight="50px"
                                        borderRadius={"10px"}
                                    />
                                    <CloudArrowUp
                                        size={24}
                                        color={COLORS.brand}
                                        weight="duotone"
                                    />
                                    <FormLabel
                                        textTransform="capitalize"
                                        marginRight={0}
                                        onClick={clickInput}
                                        cursor={"pointer"}
                                    >
                                        Upload photo
                                    </FormLabel>
                                </HStack>
                            </VStack>
                        </HStack>
                        <FormInput
                            onBlur={formik.handleBlur}
                            type="text"
                            name="title"
                            label="title"
                            placeholder="Enter Title"
                            value={values.title}
                            error={!!touched.title && errors.title}
                            onChange={(e) => handleChange("title", e.target.value)}
                            errorMsg={errors.title}
                            isRequired={true}
                        />
                        <TextArea
                            onBlur={formik.handleBlur}
                            type="text"
                            name="content"
                            label="content"
                            placeholder="Enter content"
                            value={values.content}
                            error={!!touched.content && errors.content}
                            onChange={(e) => handleChange("content", e.target.value)}
                            errorMsg={errors.content}
                            isRequired={true}
                        />
                    </VStack>
                </ModalBody>
                <ModalFooter justifyContent={"flex-start"}>
                    <Button
                        size={"lg"}
                        isLoading={btnLoading}
                        spinner={
                            <DotSpinner
                                key={"campaign-manager-edit-basic-form"}
                                color={"#fff"}
                                size={8}
                            />
                        }
                        type="submit"
                        colorScheme="brand"
                        className="custom-btn"
                        padding={"5"}
                        width={"250px"}
                        _hover={{ backgroundColor: COLORS.lightPink }}
                        backgroundColor={COLORS.brand}
                    >
                        {type === "ADD" ? "Create Notification" : "Update Notification"}
                    </Button>
                </ModalFooter>
            </form>
        </Box>
    )
}
